import { Injectable } from '@angular/core';
import { CommonAccessTokenService, NetworkHelper } from '@wm-libs/core';
import { Observable, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Rewards, RewardsParams } from '../interfaces//rewards.interface';
import { StorageService } from '@wm-libs/core';

@Injectable({
  providedIn: 'root',
})
export class RewardsService {
  readonly apiUrl = `${environment.poolApi}/income`;
  readonly apiAccessTokenUrl = `${environment.poolApi}/access-token/income`;
  readonly apiExportUrl = `${environment.poolApi}/excel/income`;

  constructor(private networkHelper: NetworkHelper, private storageService: StorageService, private accessTokenService: CommonAccessTokenService) {}

  getRewards(params?: RewardsParams): Observable<Rewards> {
    const finalApiUrl = this.accessTokenService.isAccessTokenPage() ? this.apiAccessTokenUrl : this.apiUrl;

    return this.networkHelper.get<Rewards>(`${finalApiUrl}`, params).pipe(take(1));
  }

  exportRewards(type?: string, startTime?: number, endTime?: number): void {
    const token = this.storageService.getToken() ?? '';
    const startTimestamp = startTime ? new Date(startTime).getTime() / 1000 : undefined;
    const endTimestamp = endTime ? new Date(endTime).getTime() / 1000 : undefined;

    const params = new URLSearchParams();
    params.set('token', token);

    if (type) params.set('type', type);
    if (startTimestamp) params.set('startTime', startTimestamp.toString());
    if (endTimestamp) params.set('endTime', endTimestamp.toString());

    const exportUrl = `${this.apiExportUrl}?${params.toString()}`;

    const anchor = document.createElement('a');
    anchor.href = exportUrl;
    anchor.download = 'rewards.xlsx';
    anchor.target = '_blank';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }
}
